"use client"
import { AxisModel, Category, ChartComponent, DataLabel, Inject, Legend, MarkerSettingsModel, SeriesCollectionDirective, SeriesDirective, StackingBarSeries, Tooltip } from "@syncfusion/ej2-react-charts";
import { ReactNode, useEffect, useState } from "react";

interface StatStackedBarChartProps {
    data: {x: string, y1: number, y2: number}[],
    palettes: string[],
    primaryxAxis: AxisModel,
    primaryyAxis: AxisModel,
    title: string,
    name: {y1: string, y2: string},
    template1?: (args: any) => ReactNode
    template2?: (args: any) => ReactNode
    rowHeight?:number,
    getHeight?: (length: number) => number
}
export const StatsStackedBarChart: React.FC<StatStackedBarChartProps> = ({data, palettes, primaryxAxis, primaryyAxis, title, name, template1, template2, getHeight, rowHeight }) => {
    const marker1: MarkerSettingsModel  = { visible: false, dataLabel: { visible: true , template: template1, position: "Bottom"} };
    const marker2: MarkerSettingsModel  = { visible: false, dataLabel: { visible: true , template: template2, position: "Bottom"} };
    const calcHeight = () => getHeight?getHeight(data.length):data.length*(rowHeight??50);
    const [height, setHeight] = useState(calcHeight());
    useEffect(()=>{
      //Force rebuild to readjust height
      setHeight(0);
      setHeight(calcHeight());
    }, [data, rowHeight])
    if (height === 0) return <div></div>
    return <ChartComponent
        //Add legends height
        height={(height + 80).toString()}
        legendSettings={{ visible: true }}
        primaryXAxis={primaryxAxis}
        primaryYAxis={primaryyAxis}
        title={title}
        palettes={palettes}>
    <Inject services={[Legend, StackingBarSeries, Tooltip, DataLabel, Category ]}/>
    <SeriesCollectionDirective>
      <SeriesDirective dataSource={data} xName='x' yName='y1' type='StackingBar' marker={marker1} name={name.y1}>
      </SeriesDirective>
      <SeriesDirective dataSource={data} xName='x' yName='y2' type='StackingBar' marker={marker2} name={name.y2}>
      </SeriesDirective>
    </SeriesCollectionDirective>
  </ChartComponent>;
}